module.exports = __webpack_public_path__ + "img/image_001.c199a238.png";